import { defineStore } from "pinia";

import permissionRolesApi from "@/services/api/permissionRolesApi";

import { getCompanyId } from "@/utils/userUtils";

export const usePermissionRolesStore = defineStore(
  "permissionRoles",
  {
    state: () => ({
      roles: [],
      currentRole: null,
      grid: { groups: [], resources: [] },
      isLoading: false,
      pagination: { page: 1, pages: 1, series: [] },
    }),

    getters: {
      getRoleById: (state) => (id) =>
        state.roles.find((r) => String(r.id) === String(id)) || null,
    },

    actions: {
      async fetchRoles(params = {}) {
        this.isLoading = true;
        try {
          const companyId = getCompanyId();
          const response = await permissionRolesApi.index(
            companyId,
            params
          );
          this.roles = response.data.result || [];
          if (response.data.pagination_meta) {
            this.pagination = response.data.pagination_meta;
          }
        } catch (error) {
          console.error("Ошибка при загрузке ролей:", error);
        } finally {
          this.isLoading = false;
        }
      },

      async fetchGrid(id) {
        this.isLoading = true;
        try {
          const companyId = getCompanyId();
          const response = await permissionRolesApi.grid(
            companyId,
            id
          );
          this.grid = response.data.result || response.data;
          return this.grid;
        } catch (error) {
          console.error("Ошибка при загрузке прав:", error);
        } finally {
          this.isLoading = false;
        }
      },

      async createRole(data) {
        const companyId = getCompanyId();
        const response = await permissionRolesApi.create(
          companyId,
          data
        );
        const created = response.data.result;
        this.roles.unshift(created);
        return created;
      },

      async updateRole(id, data) {
        const companyId = getCompanyId();
        const response = await permissionRolesApi.update(
          companyId,
          id,
          data
        );
        const updated = response.data.result;
        const idx = this.roles.findIndex((r) => r.id === updated.id);
        if (idx !== -1) this.roles.splice(idx, 1, updated);
        if (this.currentRole?.id === updated.id)
          this.currentRole = updated;
        return updated;
      },

      async deleteRole(id) {
        const companyId = getCompanyId();
        await permissionRolesApi.delete(companyId, id);
        this.roles = this.roles.filter((r) => r.id !== id);
      },

      async togglePermission(
        roleId,
        targetResource,
        permissionAction
      ) {
        const companyId = getCompanyId();
        const response = await permissionRolesApi.toggle(
          companyId,
          roleId,
          targetResource,
          permissionAction
        );
        this.grid = response.data.result || response.data;
      },

      async updateResourceScope(roleId, targetResource, dataScope) {
        const response = await permissionRolesApi.resourceScope(
          getCompanyId(), roleId, targetResource, dataScope
        );
        this.grid = response.data.result || response.data;
      },

      async resetToDefault(id) {
        const companyId = getCompanyId();
        await permissionRolesApi.resetToDefault(companyId, id);
        await this.fetchGrid(id);
      },
    },
  }
);
